// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__KNri9","footer":"ModalUpdate_footer__36Wjv"};